import {Component, OnInit} from '@angular/core';
import {LgLogicObjectBaseComponent} from "../lg-logic-object-base.component";

@Component({
    selector: 'mvs-lg-logic-object-component-full',
    templateUrl: 'lg-logic-object-full.component.html',
    standalone: false
})
export class LgLogicObjectFullComponent extends LgLogicObjectBaseComponent implements OnInit {

    /**
     * load and initialize sidebar navigations
     *
     * Only the two unconditional sections are listed here. The other two sections the template
     * renders are appended by {@link LgLogicObjectBaseComponent#applyConditionalNavigationItems},
     * which runs right after this method: `quickTest` for every language, `mappings` only for a
     * mapping logic. They must NOT be repeated here — an unconditional `mappings` entry would offer
     * the mapping section for logics that have no mapping table at all.
     */
    loadSideBarMenuItems() {
        this.navigationItems = [
            {
                label: 'Logik',
                action: 'Logic',
                tooltip: 'Logik-Definition',
                icon: 'fa-regular fa-square-code',
                toggleable: false,
                default: true
            },
            {
                label: 'Testfälle',
                action: 'TestCases',
                tooltip: 'Hinterlegte Testfälle',
                icon: 'fa-regular fa-flask-vial',
                toggleable: false,
                default: false
            },

        ];

        this.activeNavigationItem = this.navigationItems[0];
        this.handleNavigationItemsChange();
    }
}
